import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-fullcalendar',
	templateUrl:'./FullCalendarPluginPage.html',
	styles: [],
	styleUrls:['./FullCalendarPluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class FullCalendarPluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_581 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>full-calendar</artifactId>
</dependency>
\`\`\``;
	mdContent_582 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:full-calendar:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_583 = `\`\`\`json
"@fullcalendar/luxon2": "^6.1.19"
"@fullcalendar/bootstrap5": "^6.1.19"
"@fullcalendar/angular": "^6.1.19"
"@fullcalendar/daygrid": "^6.1.19"
"@fullcalendar/list": "^6.1.19"
"@fullcalendar/interaction": "^6.1.19"
"@fullcalendar/moment-timezone": "^6.1.19"
"@fullcalendar/timegrid": "^6.1.19"
\`\`\``;
	mdContent_584 = `\`\`\`java
FullCalendarOptions options = new FullCalendarOptions()
    .setInitialView("dayGridMonth")
    .setEditable(true)
    .setHeaderToolbar(new Toolbar()
        .setLeft("prev,next today")
        .setCenter("title")
        .setRight("dayGridMonth,timeGridWeek,listWeek"))
    .addEvent(new Event()
        .setTitle("Sprint Planning")
        .setStart("2026-03-24T10:00:00")
        .setEnd("2026-03-24T11:30:00"));
\`\`\``;
	mdContent_585 = `\`\`\`java
FullCalendarOptions options = new FullCalendarOptions()
    .setInitialView("dayGridMonth")
    .setLocale("en")
    .setTimeZone("UTC")
    .setEditable(true)
    .setHeaderToolbar(new Toolbar()
        .setLeft("prev,next today")
        .setCenter("title")
        .setRight("dayGridMonth,timeGridWeek,listWeek"))
    .addEvent(new Event()
        .setTitle("Team Meeting")
        .setStart("2026-03-24T10:00:00")
        .setEnd("2026-03-24T11:00:00"));
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
